import { Bundle, ScheduleGroup } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(guid: string) {
  return DesignService.get<ScheduleGroup>(`scheduleGroups/${guid}`);
}

export function getForOrganization() {
  return DesignService.get<readonly ScheduleGroup[]>(`scheduleGroups/forOrganization`);
}

export function insert(scheduleGroup: ScheduleGroup) {
  return DesignService.post<void>('scheduleGroups', { data: scheduleGroup });
}

export function update(scheduleGroup: ScheduleGroup) {
  return DesignService.put<void>('scheduleGroups', { data: scheduleGroup });
}

export function remove(guid: string) {
  return DesignService.delete<readonly Bundle[]>(`scheduleGroups/${guid}`);
}
